/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

export const IdipUrl = {
  Prestige:
    '//personalbanking.bankofireland.com/app/uploads/BOI-Motor-Prestige-Product-IPID-0324.pdf',
  Popular:
    '//personalbanking.bankofireland.com/app/uploads/BOI-Motor-Popular-Product-IPID-0324.pdf'
};

// boi.com
export const termsOfUseUrl = '//boi.com/insurancehometou';
export const termsOfUseMotorUrl = '//boi.com/insurancemotortou';
export const termsOfUseTravelUrl = '//boi.com/insurancetraveltou';
export const commissionStatementSummaryUrl = '//boi.com/insurancecss';
export const dataPrivacyMotorUrl = '//boi.com/insurancemotordpn';
export const dataPrivacyHomeUrl = '//boi.com/insurancehomedpn';
export const dataPrivacyTravelUrl = '//boi.com/insurancetraveldpn';
export const ipidTravelUrl = '//boi.com/insurancetravelipid';
export const motorPolicyBooklet = '//boi.com/insurancemotorpolicybooklet'
export const travelTermsOfBusinessUrl = '//boi.com/insurancetraveltc'
export const travelChubbTermsOfBusinessUrl = '//boi.com/insurancetravelctc';
export const homeAccessibilityUrl = `https://www.bankofireland.com/legal/accessibility/`;

// bankofireland.com
export const policyImportantDocuments =
  '//personalbanking.bankofireland.com/insure-and-protect/insurance/home-insurance-quote/important-documents/';
export const termsOfBusinessUrl =
  '//personalbanking.bankofireland.com/app/uploads/BIIS-Terms-of-business-March-2026.pdf';
export const travelFaqUrl =
  '//personalbanking.bankofireland.com/insure-and-protect/insurance/travel-insurance/faqs/';

export const marketingGeneralConsentUrl =
  'https://digital.bankofireland.com/services/marketing/marketing-preferences/?formtype=generalconsent#application/page/1';
export const marketingGeneralConsentFormUrl =
  'https://form.bankofireland.com/marketing-preferences/?formtype=generalconsent';
export const boiMarketingPreferenceUrl =
  'https://www.bankofireland.com/privacy/marketing-preferences/';

// boimotor
export const motorRsaCoverSummaryUrl =
  'https://boimotor.rsagroup.ie/docs/Summary%20of%20Cover.pdf'; // broken
export const motorRsaPolicyBookletUrl =
  'https://boimotor.rsagroup.ie/docs/Policy_Booklet.pdf'; // broken

export const chubbPrivacyPolicy = 'https://chubb.com/ie-en/footer/privacy-policy.aspx';
export const citizensInformation = '//www.citizensinformation.ie';
export const eirCodeUrl = 'https://finder.eircode.ie';
export const fbdClaimsUrl = 'https://www.fbd.ie/claims/home/';
export const rsaHouseholdClaimsUrl = 'https://www.intactinsurance.ie/household-claim-form';
export const rtbUrl = '//www.rtb.ie/';
export const scsiUrl = '//scsi.ie';
export const travelSubmitClaimUrl =
  '//personalbanking.bankofireland.com/insure-and-protect/insurance/travel-insurance/how-to-make-a-claim/';
